
import { toast } from "react-toastify";
import GeneralService from "../services/generalService";
import { FINANCIER_DECIMAL_LIMIT, FINANCIER_ID, FINANCIER_VALUE_LIMIT, PAYMENT_STATUS, UPLOAD_TYPE } from "../config/constants";
import * as moment from "moment";


export const getNumberFormatSeperator = (type) => {
    return (type === "number-format" && {
        thousandsGroupStyle: "thousand",
        thousandSeparator: ',',
        decimalSeparator: '.'
    }) || {};
};

export const updateObject = (originalObj, updatedObj, keysToCheck = []) => {
    return keysToCheck?.reduce((result, key) => {
        if (Array.isArray(key)) {
            result[key[1]] = updatedObj[key[0]];
        } else {
            result[key] = updatedObj[key];
        }
        return result;
    }, originalObj);
};

export const generateKeyValuePair = (rows = [], key, value) => {
    return rows?.reduce((result, element) => { result[element?.[key]] = value ? (element?.[value] || "") : element || {}; return result; }, {});
};


export const setState = async ({ state, setState, key, value, is_array = true }) => {
    setState(prev => ({
        ...prev,
        [key]: is_array ? [...state?.[key], value] : value
    }));
};

export const getDisputeCreditAvailable = (disputeData = []) => {
    return +disputeData?.reduce((result, dispute) => {
        result += +dispute?.di_recovery_amount;
        result += +dispute?.gmv_recovery_amount;
        return result;
    }, 0)?.toFixed(2) || 0;
};
export const getCreditSelected = (splitPaymentDetails = []) => {
    const resp = splitPaymentDetails?.reduce((result, tranch) => {
        if (tranch?.is_tranche_marked) {
            result.credit_selected += +tranch?.amount;
        }
        if (!tranch?.tranche_status || ![PAYMENT_STATUS.requested, PAYMENT_STATUS.paid]?.includes(tranch?.tranche_status)) {
            result.credit_can_select += +tranch?.amount;
        }
        return result;
    }, { credit_can_select: 0, credit_selected: 0 }) || { credit_can_select: 0, credit_selected: 0 };
    return { credit_can_select: +resp?.credit_can_select?.toFixed(2) || 0, credit_selected: +resp?.credit_selected?.toFixed(2) || 0 };
};

export const handleFileChange = async ({ event, max_upload = 5, state, setState, key, lead_id = 0, setIsLoading, is_array = true }) => {
    let selectedImage = event?.target?.files?.[0]?.name || "";
    let publicUrl = '', doc_path = '';
    if (!selectedImage) {
        toast.error("Please upload an image.");
        return;
    }
    if (is_array && (state?.[key]?.length || 0) >= max_upload) {
        toast.error(`Max ${max_upload} documents are allowed!`);
        return;
    }
    const formData = new FormData();
    formData.append('upload_type', UPLOAD_TYPE);
    formData.append('lead_id', lead_id);
    formData.append('images', event.target.files[0]);
    setIsLoading?.(true);
    try {
        publicUrl = await GeneralService.uploadFilesToS3(formData, { 'Content-Type': 'multipart/form-data' });
        doc_path = publicUrl?.data?.data?.[0]?.file_url || '';
    } catch (error) {
        console.error('Error uploading file:', error);
    }
    setState(prev => ({
        ...prev,
        [key]: is_array ? [...state?.[key], doc_path] : doc_path
    }));
    setIsLoading?.(false);
};

export const computationDecimalScale = (financierId) => {
    return (Number(financierId) === FINANCIER_ID.JACCS_FINANCE && FINANCIER_DECIMAL_LIMIT.JACCS_FINANCE) || FINANCIER_DECIMAL_LIMIT.DEFAULT;
};

export const computationValueLength = (financierId) => {
    return (Number(financierId) === FINANCIER_ID.JACCS_FINANCE && FINANCIER_VALUE_LIMIT.JACCS_FINANCE) || FINANCIER_VALUE_LIMIT.DEFAULT;
};

export const handleInputChange = (state, event) => {
    state(prev => ({
        ...prev,
        [event.target.id]: event.target.value
    }));
};

export const handlePatternFormatChange = (state, event, field_name) => {
    if (event.value !== undefined && field_name) {
        state(prev => ({
            ...prev,
            [field_name]: event.value
        }));
    }
};

export const handleRadioChange = (state, event) => {
    if (event?.target?.id) {
        state(prev => ({
            ...prev,
            [event?.target?.id]: event.target.value
        }));
    }
};

export const handleDateChange = (state, event, field, format = "YYYY-MM-DD") => {
    if (event) {
        let dt = moment(event).format(format) || '';
        state(prev => ({
            ...prev,
            [field]: dt
        }));

    }
};

export const handleSingleSelectChange = (state, event, field_name, isParse = false) => {
    state(currentValue => ({
        ...currentValue,
        [field_name]: (isParse && parseInt(event.value)) || event?.value
    }));
};

export const generateKeyValuesPair = (rows = [], key, value) => {
    return rows?.reduce((result, element) => {
        if (!result[element?.[key]]) result[element?.[key]] = [];
        result[element?.[key]].push(value ? (element?.[value] || "") : element || {});
        return result;
    }, {});
};
export const sanitizePayload = (payload) => {
    return Object.keys(payload)?.reduce((result, key) => {
        if (Array.isArray(payload?.[key])) {
            payload?.[key]?.length && (result[key] = payload[key]);
        } else {
            payload?.[key] && (result[key] = payload[key]);
        }
        return result;
    }, {});
}
